import { ExamUsageStatus } from '@exam-management/graphql';
import { LabelColor } from '@shared/components';

export const QSET_EXAM_USAGE_STATUS_COLOR: Record<ExamUsageStatus, LabelColor> = {
  [ExamUsageStatus.Ready]: LabelColor.SUCCESS,
  [ExamUsageStatus.Assigned]: LabelColor.INFO,
  [ExamUsageStatus.InUse]: LabelColor.WARNING,
  [ExamUsageStatus.Inactive]: LabelColor.GREY,
};

export const QSET_EXAM_USAGE_STATUS_TEXT: Record<ExamUsageStatus, string> = {
  [ExamUsageStatus.Ready]: 'Ready',
  [ExamUsageStatus.Assigned]: 'Assigned',
  [ExamUsageStatus.InUse]: 'In Use',
  [ExamUsageStatus.Inactive]: 'Inactive',
};
